const computeFormworkPace = (
  totalSurface: number | null | undefined,
  durationMonths: number | null | undefined,
): number | null => {
  const surface = Number(totalSurface);
  const duration = Number(durationMonths);
  if (!Number.isFinite(surface) || surface <= 0) return null;
  if (!Number.isFinite(duration) || duration <= 0) return null;
  const divisor = duration * 20;
  if (divisor <= 0) return null;
  return Math.round((surface / divisor) * 100) / 100;
};

export default computeFormworkPace;
